import { connect } from 'react-redux';

import React, { Component } from 'react';

import './index.css';
import '../../static/css/animate.css';
import 'owl.carousel/dist/assets/owl.carousel.css';

import Navbar from '../../components/navbar';
import { toggleLoader } from "../../store/actions/Auth";



class MPokerClub extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stage: 0,
            sticky: false,
            isNetwork: true,
            isPreSale: false,
            rate: '',
            nftPrice: '',
            quantity: 0,
            max: '',
            min: 0,
            mintItems: '',
            availableItems: '',
            contributions: '',
            openingTime: '',
            closingTime: '',
            address: localStorage.getItem('publicAddress'),
        };
    };



    componentWillReceiveProps({ publicAddress }) {
        this.setState({ address: publicAddress });
    };

  
    onScroll = () => {
        const { pageYOffset } = window;
        if (pageYOffset > 20) this.setState({ sticky: true });
        if (pageYOffset < 20) this.setState({ sticky: false });
    };

    render() {



        let { sticky } = this.state;

        return (
            <div className="mp-club-page" onWheel={this.onScroll}>
                <Navbar sticky={sticky} />
                {/* Banner Section */}
                <section id="home" className="banner-sec" style={{ backgroundImage: `url(${require("../../static/images/new-landing/banner-bg.png")})` }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="banner-text col-lg-6 col-md-12">
                                <div className="banner-inner">
                                    <div className="title-icon">
                                        <div className="img-box">
                                            <img className="left-img" src={require('../../static/images/new-landing/logo-banner.png')} alt='' />
                                        </div>
                                    </div>

                                    <div className="btn-group">
                                        <a className='banner-btn'  target="_blank" smooth href='https://webgl.modernpokerclub.com/'>
                                            <i className="play-icon"><img src={require('../../static/images/new-landing/play-icon.png')} alt='' /></i>
                                            <span>play game</span>
                                            <i className="poker-icon"><img src={require('../../static/images/new-landing/poker-icon.png')} alt='' /></i>
                                        </a>
                                    </div>

                                </div>
                            </div>
                            <div className="banner-img col-lg-6 col-md-12">
                                <div className="img-inner">
                                    <img src={require('../../static/images/new-landing/banner-left-img.png')} alt='' />

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* About Section */}
                <section id="about" className="about-sec" style={{ backgroundImage: `url(${require("../../static/images/new-landing/about-bg.png")})` }}>
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="sec-title text-center">
                                    <h2><img src={require('../../static/images/new-landing/about-title.png')} alt='' /></h2>
                                </div>

                                <div className="about-text-area">
                                    <div className="about-inner">
                                        <div className="left-area">
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/about-img.png')} alt='' />
                                            </div>
                                            <div className="social-links">
                                                <a href="https://x.com/ModernPokerClub" className="social-link" target="_blank"><img src={require('../../static/images/new-landing/twitter-icon.png')} alt='' /></a>
                                                <a href="https://opensea.io/collection/modernpokerclub" className="social-link opensea-link" target="_blank"><img src={require('../../static/images/new-landing/telegram-icon.png')} alt='' /></a>
                                                <a href="http://discord.gg/WDNCvU9X" className="social-link" target="_blank"><img src={require('../../static/images/new-landing/discord-icon.png')} alt='' /></a>
                                            </div>
                                        </div>
                                        <div className="right-area">
                                            <div className="text-box">
                                                <p>ModernPokerClub is a service that offers a play-to-earn poker card game where players discover a new style of poker with ModernPokerClub’s evolving brand of faction play, where you’ll strategize with faction mates to conquer your opponents, adorn the faction crown and reap the rewards. The game is built to fundamentally change how games work; using Solana technology to bring true digital ownership to players, as well as provide the means to earn. The $MPC token is designed to be the core currency of ModernPokerClub, fuelling the ecosystem that empowers players to earn and sell Non-Fungible Tokens (NFTs).</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >

                {/* Become Section */}
                <section id="become" className="become-sec" style={{ backgroundImage: `url(${require("../../static/images/new-landing/become-bg.png")})` }}>
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="sec-title text-center">
                                    <h2><img src={require('../../static/images/new-landing/become-title.png')} alt='' /></h2>
                                </div>

                                <div className="become-box-area">
                                    <div className="become-area">
                                        <div className="become-box become-box-1">
                                            <div className="top-img-area">
                                                <img src={require('../../static/images/new-landing/become-img-1.png')} alt='' />
                                            </div>
                                            <div className="bottom-img-area">
                                                <img src={require('../../static/images/new-landing/become-img-1-1.png')} alt='' />
                                            </div>
                                            <div className="text-box">
                                                <p>A rich poker player willing to splash and go wild </p>
                                            </div>
                                        </div>
                                        <div className="become-box become-box-2">
                                            <div className="top-img-area">
                                                <img src={require('../../static/images/new-landing/become-img-2.png')} alt='' />
                                            </div>
                                            <div className="bottom-img-area">
                                                <img src={require('../../static/images/new-landing/become-img-2-1.png')} alt='' />
                                            </div>
                                            <div className="text-box">
                                                <p>A professional poker player</p>
                                            </div>
                                        </div>
                                        <div className="become-box become-box-3">
                                            <div className="top-img-area">
                                                <img src={require('../../static/images/new-landing/become-img-3.png')} alt='' />
                                            </div>
                                            <div className="bottom-img-area">
                                                <img src={require('../../static/images/new-landing/become-img-3-1.png')} alt='' />
                                            </div>
                                            <div className="text-box">
                                                <p>A novice poker player</p>
                                            </div>
                                        </div>
                                        <div className="become-box become-box-4">
                                            <div className="top-img-area">
                                                <img src={require('../../static/images/new-landing/become-img-4.png')} alt='' />
                                            </div>
                                            <div className="bottom-img-area">
                                                <img src={require('../../static/images/new-landing/become-img-4-1.png')} alt='' />
                                            </div>
                                            <div className="text-box">
                                                <p>Despite Knowing THE Odds still makes bad decisions</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >

                {/* Become Section */}
                <section id="get-started" className="get-started-sec" style={{ backgroundImage: `url(${require("../../static/images/new-landing/get-started-bg.png")})` }}>
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="sec-title text-center">
                                    <h2><img src={require('../../static/images/new-landing/get-started-title.png')} alt='' /></h2>
                                </div>

                                <div className="get-started-area">
                                    <div className="get-started-inner">
                                        <div className="get-started-box">
                                            <div className="text-box">
                                                <p>Create phantom wallet</p>
                                            </div>
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/timeline-step-1.png')} alt='' />
                                            </div>
                                            <div className="step-box">
                                                <img src={require('../../static/images/new-landing/arrow-top.png')} alt='' />
                                                <h4>step 1</h4>
                                            </div>
                                        </div>
                                        <div className="get-started-box">
                                            <div className="text-box">
                                                <p>Purchase our ticket from Raydium</p>
                                            </div>
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/timeline-step-2.png')} alt='' />
                                            </div>
                                            <div className="step-box">
                                                <img src={require('../../static/images/new-landing/arrow-top.png')} alt='' />
                                                <h4>step 3</h4>
                                            </div>
                                        </div>
                                        <div className="get-started-box">
                                            <div className="text-box">
                                                <p>start bluffing</p>
                                            </div>
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/timeline-step-3.png')} alt='' />
                                            </div>
                                            <div className="step-box">
                                                <img src={require('../../static/images/new-landing/arrow-top.png')} alt='' />
                                                <h4>step 5</h4>
                                            </div>
                                        </div>
                                        <div className="get-started-box">
                                            <div className="text-box">
                                                <p>spend and trade</p>
                                            </div>
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/timeline-step-4.png')} alt='' />
                                            </div>
                                            <div className="step-box">
                                                <img src={require('../../static/images/new-landing/arrow-top.png')} alt='' />
                                                <h4>step 7</h4>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="get-started-inner style-two">
                                        <div className="get-started-box get-started-box-5">
                                            <div className="step-box">
                                                <h4>step 2</h4>
                                                <img src={require('../../static/images/new-landing/arrow-top.png')} alt='' />
                                            </div>
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/timeline-step-5.png')} alt='' />
                                            </div>
                                            <div className="text-box">
                                                <p>Get Solana in your wallet.</p>
                                            </div>
                                        </div>
                                        <div className="get-started-box get-started-box-6">
                                            <div className="step-box">
                                                <h4>step 4</h4>
                                                <img src={require('../../static/images/new-landing/arrow-top.png')} alt='' />
                                            </div>
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/timeline-step-6.png')} alt='' />
                                            </div>
                                            <div className="text-box">
                                                <p>Buy NFT</p>
                                            </div>
                                        </div>
                                        <div className="get-started-box get-started-box-7">
                                            <div className="step-box">
                                                <h4>step 6</h4>
                                                <img src={require('../../static/images/new-landing/arrow-top.png')} alt='' />
                                            </div>
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/timeline-step-7.png')} alt='' />
                                            </div>
                                            <div className="text-box">
                                                <p>play to earn</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >

                {/* Rewards Section */}
                <section id="rewards" className="rewards-sec" style={{ backgroundImage: `url(${require("../../static/images/new-landing/rewards-bg.png")})` }}>
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="sec-title text-center">
                                    <h2><img src={require('../../static/images/new-landing/rewards-title.png')} alt='' /></h2>
                                </div>

                                <div className="rewards-box-area">
                                    <div className="rewards-area">
                                        <div className="text-box">
                                            <p>To catalyze competitive play and stimulate engagement, players can earn meaningful rewards, including the Solana $MPC token, by simply playing the game. The ability to earn tangible rewards serves as the key ingredient to supercharge our future growth. $MPC tokens are designed to exist at the heart of the economy, being used by players to purchase time and NFTs within our club. By including $MPC in the key facets of the ModernPokerClub experience, it creates a sustainable ecosystem where players have the economic freedom to earn, and
                                                contribute to the economy.</p>
                                        </div>
                                        <div className="img-box">
                                            <img src={require('../../static/images/new-landing/rewards-img.png')} alt='' />
                                        </div>
                                    </div>
                                    <div className="prize-pool-box">
                                        <div className="prize-box">
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/prize-icon.png')} alt='' />
                                            </div>
                                            <h4>Tournament prize pool distribution</h4>
                                        </div>
                                    </div>
                                    <div className="prizes-area">
                                        <div className="prizes-box">
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/awards-1.png')} alt='' />
                                            </div>
                                            <div className="progress-area">
                                                <div className="precentage-area">
                                                    <span>1st</span>
                                                    30%
                                                </div>
                                            </div>
                                        </div>
                                        <div className="prizes-box">
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/awards-2.png')} alt='' />
                                            </div>
                                            <div className="progress-area">
                                                <div className="precentage-area">
                                                    <span>2nd</span>
                                                    20%
                                                </div>
                                            </div>
                                        </div>
                                        <div className="prizes-box">
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/awards-3.png')} alt='' />
                                            </div>
                                            <div className="progress-area">
                                                <div className="precentage-area">
                                                    <span>3rd</span>
                                                    15%
                                                </div>
                                            </div>
                                        </div>
                                        <div className="prizes-box prizes-box-four">
                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/awards-4.png')} alt='' />
                                                <p>35% of Tournament prize pools will be distributed to the winning faction participants</p>
                                            </div>
                                            <div className="progress-area">
                                                <div className="precentage-area">
                                                    <span>1st</span>
                                                    35%
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >

                {/* tokenomics Section */}
                <section id="tokenomics" className="tokenomics-sec" style={{ backgroundImage: `url(${require("../../static/images/new-landing/tokenomics-bg.png")})` }}>
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="sec-title text-center">
                                    <h2><img src={require('../../static/images/new-landing/tokenomics-title.png')} alt='' /></h2>
                                </div>

                                <div className="tokenomics-box-area">
                                    <div className="left-area">
                                        <div className="img-box">
                                            <img src={require('../../static/images/new-landing/tokenomics-left.png')} alt='' />
                                        </div>
                                    </div>
                                    <div className="right-area">
                                        <div className="img-box">
                                            <img src={require('../../static/images/new-landing/tokenomics-right.png')} alt='' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >

                {/* Buy Section */}
                <section id="buysec" className="buy-sec" style={{ backgroundImage: `url(${require("../../static/images/new-landing/buy-sec.png")})` }}>
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="sec-title text-center">
                                    <h2><img src={require('../../static/images/new-landing/buy-title.png')} alt='' /></h2>
                                </div>

                                <div className="buysec-box-area">
                                    <div className="left-area">
                                        <div className="img-box">
                                            <img src={require('../../static/images/new-landing/buy-left-img.png')} alt='' />
                                        </div>
                                    </div>
                                    <div className="right-area">
                                        <div className="heading-box">
                                            <h3>BUy now</h3>

                                            <div className="img-box">
                                                <img src={require('../../static/images/new-landing/swap-img.png')} alt='' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Join Section */}
                    <div id="joinsec" className="join-sec">
                        <div className="auto-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="sec-title text-center">
                                        <h2><img src={require('../../static/images/new-landing/join-title.png')} alt='' /></h2>
                                    </div>

                                    <div className="join-box-area">
                                        <div className="img-box">
                                            <img src={require('../../static/images/new-landing/join-img.png')} alt='' />
                                            <div className="social-links">
                                                <a href="https://x.com/ModernPokerClub" className="social-link" target="_blank"><img src={require('../../static/images/new-landing/twitter-icon.png')} alt='' /></a>
                                                <a href="https://t.me/ModernPokerClub" className="social-link opensea-link" target="_blank"><img src={require('../../static/images/new-landing/telegram-icon.png')} alt='' /></a>
                                                <a href="http://discord.gg/WDNCvU9X" className="social-link" target="_blank"><img src={require('../../static/images/new-landing/discord-icon.png')} alt='' /></a>
                                                <a href="https://www.youtube.com/@modernpokerclub7637" className="social-link" target="_blank"><img src={require('../../static/images/new-landing/youtube-icon.png')} alt='' /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        );
    }
}

const mapDispatchToProps = { toggleLoader };

const mapStateToProps = ({ Auth }) => {
    let { publicAddress } = Auth;
    return { publicAddress }
};

export default connect(mapStateToProps, mapDispatchToProps)(MPokerClub);